import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledSelectedIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.primary};
`;

export const StyledTableRow = styled.div<{ columnsLength: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columnsLength}, 1fr);
  justify-items: left;
  padding: ${(props) => props.theme.spacing.spacing5};
  column-gap: ${(props) => props.theme.spacing.spacing5};
  border-bottom: ${(props) => '1px solid ' + props.theme.colors.gray};
`;

export const StyledTableHeaderValue = styled.div`
  color: ${(props) => props.theme.colors.gray600};
  font-weight: bold;
`;
